<template>
  <div class="relative" :class="label ? 'mt-2' : ''">
    <label
      v-if="label"
      class="capitalize-first absolute -top-2 left-2 z-10 -mt-px inline-block rounded-md bg-white/75 px-1 text-xs font-medium whitespace-nowrap text-gray-900 dark:bg-slate-800/80 dark:text-white"
    >
      {{ label }}
      <span v-if="label && required" class="text-red-600">&nbsp;*</span>
    </label>
    <div
      class="divide-x overflow-hidden rounded-md border shadow-sm dark:border dark:bg-slate-700 dark:text-white"
      :class="[wFull ? 'flex flex-row' : 'inline-flex']"
      role="group"
    >
      <button
        v-for="(option, index) in options"
        :key="index"
        type="button"
        :disabled="!editionMode || disabled"
        :data-testid="name ? `${name}-${option[trackBy]}` : undefined"
        :class="[
          option[trackBy] == selectedValues
            ? 'text-contrast-primary'
            : ' enabled:hover:bg-primary-100 active:enabled:bg-primary-100 bg-white dark:bg-slate-800',
          option.bgClass && option[trackBy] == selectedValues
            ? option.bgClass
            : 'bg-primary-500 enabled:hover:bg-primary-500 enabled:hover:text-contrast-primary active:enabled:bg-primary-400',
          buttonClass,
          wFull ? 'flex-1' : '',
          { 'opacity-50': disabled }
        ]"
        class="text-sm font-medium outline-0 disabled:cursor-not-allowed"
        @click="() => (selectedValues = option[trackBy])"
      >
        <span v-if="isIcon">
          <FontAwesomeIcon class="leading-6" :icon="['fas', option['icon']]" />
        </span>
        <span v-else class="flex items-center justify-center gap-2">
          <span class="capitalize-first inline-block truncate leading-6">
            {{ option[attributeLabel] }}
          </span>
          <span
            v-if="option['badge_value']"
            class="bg-secondary text-contrast-secondary rounded-md px-1 py-0.5 text-xs leading-6"
          >
            {{ option['badge_value'] }}
          </span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'WalkmanButton',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: [String, Boolean],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    trackBy: {
      type: String,
      required: false,
      default: 'value'
    },
    attributeLabel: {
      type: String,
      required: false,
      default: 'label'
    },
    isIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedBackground: {
      type: String,
      required: false,
      default: 'bg-gray-200'
    },
    size: {
      type: String,
      default: '',
      required: false
    },
    wFull: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        emit('update:modelValue', value)
        emit('change', value)
      }
    })

    return { selectedValues }
  },
  computed: {
    buttonClass() {
      switch (this.size) {
        case 'extra-small':
          return 'px-2 py-0 gap-1 text-xs'
        case 'small':
          return 'px-2.5 py-0.5 gap-2'
        case 'large':
          return 'px-4 py-3 gap-3'
        case 'extra-large':
          return 'px-5 py-4 gap-3 text-base'
        case 'medium':
        default:
          return 'px-3 py-1.5 gap-3'
      }
    }
  }
}
</script>
